module.exports = __webpack_public_path__ + "img/Dantam Makeover 05.5afd6d65.jpg";